import React, {useEffect} from 'react';
import "./ProjMini.css";
import GitHubIcon from '@material-ui/icons/GitHub';
import FilterNoneIcon from '@material-ui/icons/FilterNone';

import AOS from "aos";
import "aos/dist/aos.css";

function ProjMini({topic, des, tech}) {
    useEffect(() => {
        AOS.init();
        AOS.refresh();
    }, []);

    return (
        <div className="ProjMini" data-aos={"fade-up"} data-aos-delay="300" >
            <div className="projmini-top">
                <FilterNoneIcon className="folder-icon" />
                <a><GitHubIcon /></a>
            </div>
            <div className="projmini-mid">
                <h4>{topic}</h4>
                <p>{des}</p>
            </div>
            <div className="projmini-tech">{tech}</div>
        </div>
    )
}

export default ProjMini
